import React from 'react';
import ConfirmDialog from 'new/elements/ConfirmDialog/ConfirmDialog';
import classes from './SwitchModeDialogOpen.module.scss';

export interface SwitchModeDialogOpenProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const SwitchModeDialogOpen = (props: SwitchModeDialogOpenProps) => {
  const { open, onClose, onConfirm } = props;

  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Switch back to Form Mode?"
      message={
        <span className={classes.switchModeDialogMessage}>
          Form Mode keeps most of your changes. Properties the form would reject will be dropped.
        </span>
      }
      confirmText="Switch to Form Mode"
      cancelText="Stay in Advanced Mode"
      variant="warning"
    />
  );
};
